import {Link} from "react-router-dom";

const GoToHomePage = () => {
	return (
		<Link to='/' className='go-to-homepage'>
			<div className='go-to-homepage__background' />
		</Link>
	);
};

export default GoToHomePage;
